"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFirmwareApiGateway = exports.getAirQualityApiGateway = exports.getWeatherApiGateway = exports.getCognitoDomain = exports.getIdentityPoolId = exports.getBaseUrl = exports.getCognitoClientId = exports.getCognitoUserPoolId = exports.getApiGatewayUrl = exports.getAwsRegion = exports.getAppSyncApiKey = exports.getAppSyncEndpoint = exports.getEnvVariable = void 0;
/**
 * Gets an environment variable with a fallback value
 * @param name The name of the environment variable
 * @param fallback The fallback value if the environment variable is not set
 * @returns The value of the environment variable or the fallback
 */
const getEnvVariable = (name, fallback = '') => {
    if (typeof process !== 'undefined' && process.env) {
        return process.env[name] || fallback;
    }
    if (typeof window !== 'undefined' && window.env && window.env[name]) {
        return window.env[name];
    }
    return fallback;
};
exports.getEnvVariable = getEnvVariable;
/**
 * Gets the AppSync GraphQL endpoint from environment variables
 * @returns The AppSync GraphQL endpoint
 */
const getAppSyncEndpoint = () => (0, exports.getEnvVariable)('APP_APPSYNC_ENDPOINT', 'https://uh24pp3r5zcqjingjrrxudfcke.appsync-api.us-west-2.amazonaws.com/graphql');
exports.getAppSyncEndpoint = getAppSyncEndpoint;
/**
 * Gets the AppSync API key from environment variables
 * @returns The AppSync API key
 */
const getAppSyncApiKey = () => (0, exports.getEnvVariable)('APP_APPSYNC_API_KEY', 'da2-acngarh35nfxxgxifuplskd3z4');
exports.getAppSyncApiKey = getAppSyncApiKey;
/**
 * Gets the AWS region from environment variables
 * @returns The AWS region
 */
const getAwsRegion = () => (0, exports.getEnvVariable)('AWS_REGION', 'us-west-2');
exports.getAwsRegion = getAwsRegion;
/**
 * Gets the API Gateway URL from environment variables
 * @returns The API Gateway URL
 */
const getApiGatewayUrl = () => process.env.EXPO_PUBLIC_API_GATEWAY_URL || 'https://develop.heartbeat.homes';
exports.getApiGatewayUrl = getApiGatewayUrl;
/**
 * Gets the Cognito User Pool ID from environment variables
 * @returns The Cognito User Pool ID
 */
const getCognitoUserPoolId = () => {
    const userPoolId = (0, exports.getEnvVariable)('AUTH_USER_POOL_ID', '');
    if (userPoolId)
        return userPoolId;
    return (0, exports.getEnvVariable)('COMPILE_COGNITO_USER_POOL_ID', 'us-west-2_KxkCrToDe');
};
exports.getCognitoUserPoolId = getCognitoUserPoolId;
/**
 * Gets the Cognito Client ID from environment variables
 * @returns The Cognito Client ID
 */
const getCognitoClientId = () => {
    const clientId = (0, exports.getEnvVariable)('AUTH_USER_POOL_CLIENT_ID', '');
    if (clientId)
        return clientId;
    return (0, exports.getEnvVariable)('COMPILE_CLIENT_ID', '14cuvdsbu7d8di4et8n9hgs43j');
};
exports.getCognitoClientId = getCognitoClientId;
/**
 * Gets the base URL from environment variables
 * @returns The base URL
 */
const getBaseUrl = (isWeb) => {
    if (isWeb && typeof window !== 'undefined') {
        const protocol = window.location.protocol;
        const hostname = window.location.hostname;
        const port = window.location.port;
        if (port) {
            return `${protocol}//${hostname}:${port}`;
        }
        return `${protocol}//${hostname}`;
    }
    return (0, exports.getEnvVariable)('BASE_URL', 'http://localhost:3000');
};
exports.getBaseUrl = getBaseUrl;
/**
 * Gets the Identity Pool ID from environment variables
 * @returns The Identity Pool ID
 */
const getIdentityPoolId = () => {
    const identityPoolId = (0, exports.getEnvVariable)('AUTH_IDENTITY_POOL_ID', '');
    if (identityPoolId)
        return identityPoolId;
    return (0, exports.getEnvVariable)('IDENTITY_POOL_ID', 'us-west-2:4e7158b4-3601-4609-ba74-417e05ed7de6');
};
exports.getIdentityPoolId = getIdentityPoolId;
/**
 * Gets the Cognito domain from environment variables
 * @returns The Cognito domain
 */
const getCognitoDomain = () => {
    const domain = (0, exports.getEnvVariable)('AUTH_DOMAIN', '');
    if (domain)
        return domain;
    return (0, exports.getEnvVariable)('COGNITO_DOMAIN', 'auth.develop.heartbeat.homes');
};
exports.getCognitoDomain = getCognitoDomain;
/**
 * Gets the Weather API Gateway from environment variables
 * @returns The Weather API Gateway
 */
const getWeatherApiGateway = () => process.env.EXPO_PUBLIC_WEATHER_API_GATEWAY || 'https://develop.heartbeat.homes/weather';
exports.getWeatherApiGateway = getWeatherApiGateway;
const getAirQualityApiGateway = () => process.env.EXPO_PUBLIC_AIR_QUALITY_API_GATEWAY || 'https://develop.heartbeat.homes/air-quality';
exports.getAirQualityApiGateway = getAirQualityApiGateway;
const getFirmwareApiGateway = () => (0, exports.getEnvVariable)('FIRMWARE_API_GATEWAY', 'http://127.0.0.1:3726');
exports.getFirmwareApiGateway = getFirmwareApiGateway;
